import React from 'react'
import { Grid } from 'semantic-ui-react'
import InputField from '../../../commonComponents/formComponents/inputField'
import DropDown from '../../../commonComponents/formComponents/dropDown'
import {  useSelector } from 'react-redux'
import { TranslateContext } from '../TranslateContext'
import SupplyUnit from './supplyUnit'
import UNDG from './undg'

const MerchForm6=({invoiceIndex, lineItemIndex, invoiceId, merchandiseId,saveData,updateData,onChange,isDMS,updateCalculatedValue,fieldPattern,validateError})=>{
  
  const transTypeList = useSelector((state) => state.DropDownValues?.transactionNature) || []
  const paymentType = useSelector((state) => state.DropDownValues?.expWaysOfPayment) || []
 
  const grossWeightQty =useSelector((state) => state.InvoicesReducer.lineItems[invoiceId][lineItemIndex]?.grossWeightQty) || ''
  const netWeightQty =useSelector((state) => state.InvoicesReducer.lineItems[invoiceId][lineItemIndex]?.netWeightQty) || ''
  const transactionType =useSelector((state) => state.InvoicesReducer.lineItems[invoiceId][lineItemIndex]?.transactionType) || ''
  const paymentMethod =useSelector((state) => state.InvoicesReducer.lineItems[invoiceId][lineItemIndex]?.paymentMethod) || ''

  const translate = React.useContext(TranslateContext).translate

  const { lineItem } = fieldPattern()?.items

  const grossWeightQtyErr = useSelector((state)=>state?.ValidationErrors.items?.[`invoice${invoiceIndex+1}_lineItem${lineItemIndex+1}_grossWeightQty`]) 
  const netWeightQtyErr = useSelector((state)=>state?.ValidationErrors.items?.[`invoice${invoiceIndex+1}_lineItem${lineItemIndex+1}_netWeightQty`]) 


  return (
    <Grid.Row>
      
    
          <Grid.Column width={isDMS ? 3 :6} className='divFormFeild b-rw-0 kg  '>
            <InputField
              isLabel={false}
              id={`grossMass-${invoiceId}-${merchandiseId}`}
              type='number'
              label={translate('GROSS_WEIGHT', { ns: ['default', 'lineItem'] })}
              value={grossWeightQty}
              className='field-bg'
              errors={grossWeightQtyErr&&grossWeightQtyErr?.msg}
              clearInput={false}
              onChange={(value) =>updateData({grossWeightQty:value})}
              onBlur={(value) => {
                updateCalculatedValue({grossWeightQty:grossWeightQty || 0})
                const key = `invoice${invoiceIndex+1}_lineItem${lineItemIndex+1}_grossWeightQty`
                validateError({[key]:""},{[key]:value},
                  {[key]:lineItem(invoiceIndex+1, lineItemIndex+1)?.grossWeightQty}
                )
              }}
            />
          </Grid.Column>
          <Grid.Column width={isDMS ? 3 :6} className='divFormFeild  kg b-rw-0 '>
            <InputField
              isLabel={false}
              id={`netMass-${invoiceId}-${merchandiseId}`}
              type='number'
              label={translate('NET_MASS', { ns: ['default', 'lineItem'] })}
              mandatory={false}
              value={netWeightQty}
              className='field-bg'
              errors={netWeightQtyErr&&netWeightQtyErr?.msg}
              clearInput={false}
              onChange={(value) =>updateData({netWeightQty:value})}
              onBlur={(value) => {
                updateCalculatedValue({netWeightQty:netWeightQty || 0})
                const key = `invoice${invoiceIndex+1}_lineItem${lineItemIndex+1}_netWeightQty`
                validateError({[key]:""},{[key]:value},
                  {[key]:lineItem(invoiceIndex+1, lineItemIndex+1)?.netWeightQty}
                )
              }}
            />
          </Grid.Column>
          

         { isDMS && 
         <React.Fragment>
        <Grid.Column width='3' className='divFormFeild  b-rw-0 '>
        <SupplyUnit 
          invoiceId={invoiceId}
          merchandiseId={merchandiseId}
          lineItemIndex={lineItemIndex}
          updateData={updateData}
          saveData={saveData}
          translate={translate}
          />
           
          </Grid.Column>
         <Grid.Column width='3' className='divFormFeild b-rw-0'>
            <DropDown
              id={`transType-${invoiceId}-${merchandiseId}`}
              label={translate('TRANS_TYPE', { ns: ['default', 'lineItem'] })}
              className='field-bg dropdown100'
              labelClass='text-none'
              isLabel={true}
              mandatory={false}
              data={transTypeList}
              value={transactionType}
              clearable
              onChange={(value) => {
                updateData({transactionType:value?.trim()})
                saveData({transactionType:transactionType})
              }}
             
            />

            
          </Grid.Column>
          <Grid.Column width='4' className='divFormFeild'>
            
            <DropDown
              id={`paymentType-${invoiceId}-${merchandiseId}`}
              label={translate('PAYMENT_METHOD', { ns: ['default', 'lineItem', 'header'] })}
              className='field-bg dropdown100'
              labelClass='text-none'
              isLabel={true}
              data={paymentType}
              value={paymentMethod}
              clearable
              onChange={(value) => {
                updateData({paymentMethod:value?.trim()})
                saveData({paymentMethod:paymentMethod})
              }}
             
            />

          </Grid.Column>
        </React.Fragment>
}

 {
 !isDMS &&
 <Grid.Column width='4' className='divFormFeild'>
  <UNDG lineItemIndex={lineItemIndex} invoiceId={invoiceId} merchandiseId={merchandiseId} updateData={updateData} onChange={onChange} />
  </Grid.Column>
  }
     
    </Grid.Row>
  )
}
export default React.memo(MerchForm6) 
